import ModalTour from "./ModalTour";
export default ModalTour;
